/**
 * Business è una sezione di default dell'app: ogni utente approved la vede.
 * Non dipende da ruolo admin né da spille_access (quelli restano invariati).
 */
export function userCanAccessBusiness(user) {
  return !!user && user.status === 'approved';
}
